import axios from "axios";

export class EventCalendarService {
    getEvents() {
        return axios.get("assets/demo/data/events.json").then((res) => res.data.data);
    }
}
